// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widgetEditPanel {
  width: 350px;
  max-width: 90vw;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/job/components/dashboard/dialogs/widget-edit-dialog/widget-edit-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;AACJ","sourcesContent":[".widgetEditPanel {\n    width: 350px;\n    max-width: 90vw;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
